import { fetchApi } from '@/config/axiosSetting.ts';
import { CulpritInformationQuery } from '@/modules/FileDetail/queries/culpritInformation/culpritInformationQuery.type.ts';

export const culpritInformationQueryFunction = (
  id: string,
): Promise<CulpritInformationQuery> =>
  fetchApi.get(`/file_information/${id}/culprit_information/`);
